import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  choiceText: {
    width: '100%',
    height: 40,
    padding: theme.spacing(1),
    borderRadius: 4,
    minWidth: 85,
  },
}))
export default function ChoiceTextField(props) {
  const classes = useStyles()
  return (
    <input
      {...props}
      className={clsx({
        'formz-field-table-text-choice': true,
        [classes.choiceText]: true,
      })}
    />
  )
}
